import VueCookies from 'vue-cookies';

export default (Vue) => {
    Vue.use(VueCookies);
};
